import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview", "input", "toggleButton"]

  ERROR_MESSAGE = "<p>プレビューの生成に失敗しました。</p>"

  connect() {
    this.csrfToken = this.getCSRFToken()
  }

  async togglePreview(event) {
    event.preventDefault()

    if (this.previewTarget.style.display === 'none') {
      await this.showPreview()
    } else {
      this.hidePreview()
    }
  }

  async showPreview() {
    const content = this.inputTarget.value.trim()

    if (!content) {
      console.error("Content is empty")
      this.previewTarget.innerHTML = this.ERROR_MESSAGE
      this.previewTarget.style.display = 'block'
      this.toggleButtonTarget.textContent = 'プレビューを隠す'
      return
    }

    try {
      const response = await fetch('/api/v1/markdown/convert', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.csrfToken
        },
        body: JSON.stringify({ content })
      })

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const data = await response.json()
      this.previewTarget.innerHTML = data.html
    } catch (error) {
      console.error("Error generating preview:", error)
      this.previewTarget.innerHTML = this.ERROR_MESSAGE
    }

    this.previewTarget.style.display = 'block'
    this.toggleButtonTarget.textContent = 'プレビューを隠す'
  }

  hidePreview() {
    this.previewTarget.style.display = 'none'
    this.toggleButtonTarget.textContent = 'プレビューを表示'
  }

  getCSRFToken() {
    const metaTag = document.querySelector('meta[name="csrf-token"]')
    return metaTag ? metaTag.getAttribute('content') : ''
  }
}
